import "Root.scss"
import "@fortawesome/fontawesome-pro/css/all.css"

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles"
import { Route, Switch } from "react-router-dom"
// import { grey, indigo, red } from "@material-ui/core/colors"

import Achieve from "views/Achieve/Achieve"
import ActionStatusConstants from "helpers/ActionStatusConstants"
import { ConnectedRouter } from "connected-react-router"
import Dashboard from "views/Dashboard/Dashboard"
import Illustrate from "views/Illustrate/Illustrate"
import Welcome from "views/Welcome/Welcome"
import Maintain from "views/Maintain/Maintain"
import PropTypes from "prop-types"
import React from "react"
import { authGetUserAction } from "store/actions/Actions"
import { connect } from "react-redux"
// import cssVars from "Root.scss"
import SessionExpirationModal from "components/SessionExpirationModal/SessionExpirationModal"
import Alert from "components/Alert/Alert"
import NotFound from "views/Welcome/NotFound"
import Settings from "views/Settings/Settings";
import DashboardUser from "views/Dashboard/DashboardUser"

const theme = createMuiTheme({
    palette: {
        // type: 'light',
        // primary: indigo,
        // secondary: grey,
        // error: red,
        // Used by `getContrastText()` to maximize the contrast between the background and
        // the text.
        // contrastThreshold: 3,
        // Used to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        // tonalOffset: 0.2,
    },
    typography: {
        // This is equivalent to html {font-size: 62.5%}
        // which is 10px but setting it as a % lets it adapt to
        // the user changing the default browser font size
        // htmlFontSize: 10,
        // Since we only use 1 font-family, we can define it in the theme
        // fontFamily: cssVars.fontFamily1
    },
    MuiButton: {}
})

/**
 * Root component. Wraps our app in MUI's theme provider and manages
 * authorization routing. Depending on whether user is logged in, injects
 * the relevant main view. If login state changes, redirects to the correct view.
 */
class Root extends React.Component {
    componentDidMount() {
        this.props.authGetUserAction();

        // pure chat
        window.fwSettings={
            'widget_id':48000001443
            };
            !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}();
            (function () {
                var script = document.createElement('script');
                script.async = true;
                script.type = 'text/javascript';
                script.src = 'https://widget.freshworks.com/widgets/48000001443.js';
                document.getElementsByTagName('HEAD').item(0).appendChild(script);
            })();
    }
    render() {
        return (
            <ConnectedRouter history={this.props.history}>
                <React.Fragment>
                    <MuiThemeProvider theme={theme}>
                        <Alert />
                        <SessionExpirationModal />
                        {this.props.status === ActionStatusConstants.SUCCESS &&
                            (this.props.isLoggedIn
                                ?
                                <Switch>
                                    
                                    <Route exact path="/settings" component={Settings} />
                                    <Route path="/achieve" component={Achieve} />
                                    <Route path="/illustrate" component={Illustrate} />
                                    <Route path="/login" component={Welcome} />
                                    <Route path="/maintain" component={Maintain} />
                                    <Route exact path="/:entity?/:id?" component={this.props && this.props.is_admin ? Dashboard : DashboardUser} />
                                    {/* 404 page, for now Login */}
                                    {/* <Route component={Welcome} /> */}
                                    <Route component={NotFound} />

                                </Switch>
                                :
                                <Switch>
                                    <Route component={Welcome} />
                                </Switch>
                            )
                        }
                        
                    </MuiThemeProvider>
                </React.Fragment>
            </ConnectedRouter>
        )
    }

    static propTypes = {
        isLoggedIn: PropTypes.bool.isRequired,
        status: PropTypes.string.isRequired,
        is_admin: PropTypes.bool.isRequired,
        history: PropTypes.object.isRequired,
        authGetUserAction: PropTypes.func.isRequired
    }
}

const mapStateToProps = state => {
    const is_admin = (state.UserOrgSiteReducer && state.UserOrgSiteReducer.selected && state.UserOrgSiteReducer.selected.is_admin) ? state.UserOrgSiteReducer.selected.is_admin : false;
    return ({
        isLoggedIn: state.AuthReducer.isLoggedIn,
        status: state.AuthReducer.status,
        is_admin,
    });
};

const mapDispatchToProps = {
    authGetUserAction
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Root)
